module.exports = __webpack_public_path__ + "img/play@2x.eedcb3cd.png";